import { SyoApi, SyoLib } from '@syope/syo-bilan';
import { tristatePresent, tristateValue } from './utils';
import React from 'react';
import { getDateFromISO, getTimeFromISO } from '../utils/luxon';
import { Ended, ErrorStyled, Grey, InProgress } from './PrescriptionBilan';

export const isMed = (p: SyoLib.Prescription | null) => p?.prescription_type === 'MEDICATION';

export const procurationName = (h: SyoApi.PrescriptionHeader | null) =>
  h?.procuration_name && h?.procuration_name !== '' ? h?.procuration_name : '-Non renseigné-';

export const displayQualification = (qualification: SyoApi.PrescriptionQualification) => {
  return (tristatePresent(qualification?.qualification_problem)
    || tristatePresent(qualification?.qualification_clinic)
    || tristatePresent(qualification?.qualification_perceived)
  ) && (
    <>
      <Grey>Problème lors de la réalisation : {tristateValue(qualification?.qualification_problem)}
        {tristatePresent(qualification?.qualification_problem)
          && qualification?.qualification_problem_desc
          && (<>, {qualification?.qualification_problem_desc}</>)}
      </Grey>
      <Grey>Amélioration clinique : {tristateValue(qualification?.qualification_clinic)}</Grey>
      <Grey>Amélioration ressentie : {tristateValue(qualification?.qualification_perceived)}</Grey>
    </>);
};

export const completeStateHtml = (h: SyoApi.PrescriptionHeader | null, p: SyoLib.Prescription | null) => {
  const time = getTimeFromISO(p?.last_prescription_status?.observed_at ?? '', 'TIME_24_SIMPLE');
  const date = getDateFromISO(p?.last_prescription_status?.observed_at ?? '', 'DATE_SHORT');
  const userName = lastStatusUserName(p);

  const realise = h?.asu ? 'Réalisé' : 'Réalisée';
  const administre = h?.asu ? 'Administré' : 'Administrée';

  switch (p?.last_prescription_status?.state) {
    case 'IN_PROGRESS':
      return (
        <InProgress>
          {userName} a accusé réception de cette prescription à {time} le {date}
        </InProgress>
      );
    case 'REFUSED':
      return (
        <ErrorStyled>
          Déclarée irréalisable par {userName} à {time} le {date}
        </ErrorStyled>
      );
    case 'CANCELED':
      return (
        <ErrorStyled>
          Annulée par {userName} à {time} le {date}
        </ErrorStyled>
      );
    case 'COMPLETED':
      return (
        <Ended>
          {isMed(p) ? administre : realise} par {userName} à {time} le {date}
        </Ended>
      );
    default:
      return '';
  }
};

export const lastStatusUserName = (p: SyoLib.Prescription | null) => {
  if (!p) return '';
  const lastStatus = p.status.find((it: SyoApi.PrescriptionStatus) => it.id === p.last_prescription_status.id);
  if (!lastStatus) return '';
  return (
    lastStatus.administrateur_full_name && lastStatus.administrateur_full_name !== ''
      ? lastStatus.administrateur_full_name
      : lastStatus.user.full_name
      ?? ''
  );
};

export const getPrescriptionLastComment = (p: SyoApi.Prescription) => {
  if (!p) return ''
  return p.last_prescription_status?.comment && p.last_prescription_status?.comment !== ''
    ? p.last_prescription_status?.comment
    : p.comment && p.comment !== '' ? p.comment : 'Pas de commentaire'
};